<template>
  <div v-if="((content??'')?.replace('<p></p>', '').trim().length ?? 0) > 0 && !hasOnlyTags(content??'')"
    class="card mt-3" :class="[props.discreet ? 'border-0': 'text-dark bg-light']">
    <div class="card-body ql-editor footer-message-card" v-html="normalizeRichTextContent(content)"></div>
  </div>
</template>

<script lang="ts" setup>
import { hasOnlyTags, normalizeRichTextContent } from '@/compositions/helper';
import { computed } from 'vue';
import { useTravelConfigStore } from '@/stores/travelConfigStore';
import { storeToRefs } from 'pinia';
const travelConfigStore = useTravelConfigStore();
const { travelMessages } = storeToRefs(travelConfigStore)

const model = defineModel<string|null>();

const props = withDefaults(defineProps<{
  messageKey?: string;
  discreet?: boolean;
}>(), {
  discreet: false
});

const messageContent = computed<string | null>(() => {
  if (props.messageKey && travelMessages.value && props.messageKey in travelMessages.value) {
    return travelMessages.value[props.messageKey as keyof typeof travelMessages.value] ?? null;
  }
  return null;
});

const content = computed(() => {
  return messageContent.value ?? model.value;
});
</script>

<style>
  .footer-message-card p {
    margin-bottom: 0px;
  }
</style>
